import { Injectable } from '@angular/core';
import * as Constants from '@emi/shared/constants';
import { SkuPriceDto, SkuPriceRequest } from '@emi/shared/models';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { HttpService } from '../http.service';


@Injectable({
  providedIn: 'root'
})
export class SkuPricesService {

  constructor(private httpService: HttpService) { }

  public getSkuPrices(request: SkuPriceRequest): Observable<SkuPriceDto> {
    return this.httpService.getHttp<SkuPriceDto>(Constants.ServiceConstants.SKUS_PRICES, request).pipe(shareReplay(1));
  }
}
